import { Enum } from "./Enum";

export const VOUCHER = Object.freeze({
  GET_ALL: "/voucher",
  GET_BY_CODE: (code: string = ":code") => `/voucher/code/${code}`,
  APPLY_VOUCHER: (code: string = ":code") => `/voucher/apply/${code}`,
  VOUCHER_REVERT: (code: string = ":code") => `/voucher/voucher-revert/${code}`,
});

export type E_VOUCHER = Enum<typeof VOUCHER>;
